/* eslint-disable */
import { createSelector } from 'reselect';
import ordersSelector from './Orders.selector';

/**
 * Select the linked orders
 * @returns {any | null} The linked orders
 */
const ordersLinkedSelector = createSelector(ordersSelector, (orders) => orders.linkedOrders);

export default ordersLinkedSelector;
